import {InputType} from 'module/CustomField/util/CFInputType'
import {getMemoSelectedSize, isMemoAutoAddActive} from 'module/Memo/util/MemoUtil'
import {getDqMemoKey} from 'module/Memo/util/MemoKey'
import {CustomFieldTO} from 'generated/JavaTO'


const EnabledInputTypes = [
	InputType.Dq,
	InputType.DqLabel,
	InputType.DqMulti,
	InputType.Kost,
]

export interface MemoParams {
	memoKey: string
	memoSize: number
	memoAutoAdd: boolean
}

export function useMemoParams(cfDef: CustomFieldTO): MemoParams {
	const {dqKey, input} = cfDef
	let memoEnabled = Boolean(dqKey?.trim() && EnabledInputTypes.includes(input as InputType))
	const memoSize = memoEnabled ? getMemoSelectedSize(cfDef) : 0
	let memoKey = getDqMemoKey(dqKey)
	const memoAutoAdd = isMemoAutoAddActive(cfDef)
	if (!memoEnabled || !memoKey || !memoSize) return {memoKey: '', memoSize: 0, memoAutoAdd: false}
	return {memoKey, memoSize, memoAutoAdd}
}
